export const FolderOpen01 = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
   return (
      <svg
         width="18"
         height="18"
         viewBox="0 0 18 18"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         {...props}
      >
         <g clipPath="url(#clip0_683_5075)">
            <path
               d="M0 13.5V3.75C0 2.0955 1.3455 0.75 3 0.75H4.5C4.848 0.75 5.196 0.83175 5.5065 0.987L7.87275 2.1705C7.97625 2.22225 8.0925 2.24925 8.208 2.24925H12C14.0677 2.24925 15.75 3.9315 15.75 5.99925H7.518C5.5395 5.99925 3.76575 7.32375 3.2025 9.2265L1.19775 16.2308C0.465 15.546 0 14.5793 0 13.5ZM17.6198 8.26275C17.2605 7.7805 16.713 7.50375 16.1138 7.494C16.1025 7.494 16.0935 7.5 16.0823 7.5H7.518C6.1995 7.5 5.01675 8.38275 4.6425 9.6465L2.529 17.0287C2.91375 17.1623 3.32025 17.25 3.75 17.25H13.1685C14.838 17.25 16.281 16.176 16.77 14.5448L17.919 9.95775C18.0945 9.37125 17.985 8.754 17.6198 8.26275Z"
               fill="currentColor"
            />
         </g>
         <defs>
            <clipPath id="clip0_683_5075">
               <rect width="18" height="18" fill="currentColor" />
            </clipPath>
         </defs>
      </svg>
   )
}
